import React from "react";
import { Col, Row } from "react-grid-system";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import footerLogo from "../images/bioline-footer-logo.svg";

const HcpFooter = () => {
  return (
    <div className="centered-content">
      <div className="footer-wrapper">
        <Row align="center" justify="between" className="row">
          <Col lg={2.5} xl={3} className="col">
            <div className="site-footer__logo">
              <Link to="/">
                <img src={footerLogo} alt="BioLineRx Logo" />
              </Link>
            </div>
            <div className="site-footer__copyright mobile-only">
              <span>
                ©2024 BioLineRx Ltd.
                <br /> All rights reserved.
              </span>
            </div>
          </Col>
          <Col md={7} lg={7.5} xl={7} className="col">
            <div className="site-footer__nav">
              <nav>
                <ul>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use">Terms of Use</Link>
                  </li>
                  <li>
                    <Link to="/expanded-access-policy">
                      Expanded Access Policy
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          </Col>
          <Col md={5} lg={1.75} xl={2} className="col">
            <div className="site-footer__socials">
              <ul>
                <li>
                  <a
                    href="https://www.linkedin.com/company/biolinerx/?originalSubdomain=il"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faLinkedinIn} />
                    <span className="font-0">LinkedIn</span>
                  </a>
                </li>
                <li className="twitter-logo">
                  <a
                    href="https://twitter.com/biolinerx_ltd"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      id="x"
                      xmlns="http://www.w3.org/2000/svg"
                      width="34.971"
                      height="35"
                      viewBox="0 0 34.971 35"
                    >
                      <path
                        id="X_logo_2023_original"
                        d="M20.816,14.822,33.837,0H30.752L19.441,12.867,10.414,0H0L13.654,19.459,0,35H3.084L15.021,21.409,24.557,35H34.971M4.2,2.278H8.936L30.75,32.834H26.01"
                        fill="#d93f04"
                      />
                    </svg>
                    <span className="font-0">Twitter</span>
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col>
            <div className="site-footer__copyright desktop-only">
              <span>
                ©2024 BioLineRx Ltd. <span className="desktop-only">|</span>{" "}
                <br /> All rights reserved.
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default function Footer({ ...props }) {
  return (
    <footer {...props} className="site-footer">
      <HcpFooter />
    </footer>
  );
}

Footer.propTypes = {};
